import api from '../../../services/api';
import {
  normalizeOrderSettlement,
  type OrderSettlementDto,
} from '../../../dto/orderSettlement';

/**
 * Read-only view of the order's invoice ledger. Revenue and cost are
 * recognized only by approving sales and purchase invoices; there is no
 * manual settlement command.
 */
export async function fetchOrderSettlement(
  orderId: string,
  entity = 'orders.settlement',
): Promise<OrderSettlementDto> {
  const response = await api.get(`/orders/${encodeURIComponent(orderId)}/settlement`);
  return normalizeOrderSettlement(response.data, entity);
}
